<template>
    <div class="system-set-container">
        <div class="con">
      <el-form label-position="right" size="small" class="form" label-width="180px" ref="form"
        :model="form">
        <el-form-item :label="v.name" v-for="(v,c) in formlist" :key="c">
            <el-input v-model="v.value" readonly :show-password="v.isPassword" class="form-input">
                <div slot="suffix">
                    <span style="margin-right: 5px">{{ v.unit }}</span>
                    <i class="el-icon-edit edit" @click="openEdit(v)"></i>
                </div>
            </el-input>
        </el-form-item>
      </el-form>
      <el-dialog :title="editTitle" :visible.sync="dialogVisible" width="30%" center >
        <el-form :model="editForm" ref="editForm" label-width="auto">
            <el-form-item prop="value" :label="exchangeRate">
                <el-input v-model="editForm.value">
                    <div slot="suffix">
                    <span style="margin-right: 5px">{{ editForm.unit }}</span>
                </div>
                </el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="onCancel">取 消</el-button>
            <el-button type="primary" @click="submitEdit">确 定</el-button>
        </div>
      </el-dialog>
    </div> 
    </div>
    </template>
    <script>
    import { getSystemSet, submitSystemSet } from '@/api/archive'
    export default {
    name: 'systemSet',
    data() {
    return {
        exchangeRate: '',
        form: {},
        editTitle: '',
        editForm: {
            value: '',
            id: '',
            dictKey: '',
            parentId: '',
        },
        params:  'system_set',
        formlist: [
                    {
                        name: '显示最近几日通知:',
                        prop: 'showNoticeDay',
                        unit: '天',
                        id:'',
                        value: '',
                        isPassword: false,
                    },
                    {
                        name: '美元转里拉汇率:',
                        prop: 'exchangeRate',
                        unit: '₺',
                        id:'',
                        value: '',
                        isPassword: false,
                    },
                    {
                        name: '修改机时密码:',
                        prop: 'modifyShopMachineHourPassword',
                        unit: '',
                        id:'',
                        value: '',
                        isPassword: true,
                    },
                    {
                        name: '修改操作员机时密码:',
                        prop: 'operatorPassword',
                        unit: '',
                        id:'',
                        value: '',
                        isPassword: true,
                    },
                    {
                        name: '保修周期（月）',
                        prop: 'warrantyPeriod',
                        unit: '月',
                        id:'',
                        value: '',
                        isPassword: false,
                    },
                    {
                        name: '报修结束时间（月）',
                        prop: 'warrantyEndTime',
                        unit: '月',
                        id:'',
                        value: '',
                        isPassword: false,
                    }
                    
        ]
    }
    },
    created() {
        this.getSystemSet()
    },
    methods: {
        getSystemSet() {
            getSystemSet({code: this.params}).then(res => {
               let data = res.data.data
               this.formlist.forEach(item => {
                const foundItem = data.find(v => v.dictKey === item.prop)
                item.id = foundItem ? foundItem.id : ''
                item.value = foundItem ? foundItem.dictValue : ''
                item.parentId = foundItem ? foundItem.parentId : ''
               })
            })
        },
        openEdit(item) {
           this.editTitle = item.name
           this.editForm.value = item.value
           this.editForm.id = item.id
           this.editForm.dictKey = item.prop
           this.editForm.parentId = item.parentId
           this.editForm.unit = item.unit
           this.dialogVisible = true
           this.exchangeRate = item.prop==='exchangeRate' ? '1.00$' : item.name
        },
        submitEdit() {
            submitSystemSet({id: this.editForm.id, dictValue: this.editForm.value, dictKey: this.editForm.dictKey,code: this.params,parentId: this.editForm.parentId}).then(res => {
                this.$message.success(res.data.msg)
                this.onCancel()
                this.getSystemSet()
            }).catch(err => {
                this.$message.error(err.data.msg)
            })
        },
        onCancel() {
            this.dialogVisible = false
            this.editTitle = ''
            this.editForm = {
                value: '',
                id: '',
            }
        }
    }
    }
    </script>
    <style scoped>
    .system-set-container {
        padding: 40px 20px 20px;
        min-height: calc(100vh - 100px);
    }
    .con {
        width: 100%;
        max-width: 600px;
        padding: 30px;
        margin: 0 auto;
    }
    .form {
        width: 100%;
    }
    .form-input {
        width: 100%;
    }
    .edit {
        cursor: pointer;
        font-size: 16px;
        transition: color 0.3s;
    }
    .edit:hover {
        color: #50C4CB;
    }
    </style>